import { render, staticRenderFns } from "./SimilarListingsYearFilter.vue?vue&type=template&id=b543dde0&"
import script from "./SimilarListingsYearFilter.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsYearFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports